<template>
    <v-card>
        <v-card-text>
            <v-container>
                <v-row dense>
                    <v-col align-self="auto">
                        {{fileData.file.name}} ({{formatSize}})
                    </v-col>
                    <v-col>
                        <v-text-field v-model="description" label="Description" dense hide-details>
                        </v-text-field>
                    </v-col>
                    <v-col
                        style="text-align:right"
                    >
                        <v-btn
                            icon
                            v-if="!fileUploaded && isValid"
                            @click.prevent.stop="startUpload"
                        >
                            <v-icon color="green">
                                mdi-file-upload
                            </v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            v-if="!fileUploaded"
                            @click.prevent.stop="remove"
                        >
                            <v-icon color="red">
                                mdi-close-circle
                            </v-icon>
                        </v-btn>
                        <v-progress-circular
                            size="22"
                            class="progress-file"
                            v-if="isValid"
                            :indeterminate="fileData.uploading"
                        ></v-progress-circular>
                    </v-col>
                    <v-col v-if="errorMessages.length">
                        <div v-for="message in errorMessages" class="file-error">
                            {{message}}
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>

export default {
    name: "FileDisplay",
    props: {
        'input': {
            type: Object,
            required: true,
            default: function () {
                return undefined
            }
        },
        fileIndex: 0,
        minSize: Number,
        maxSize: Number,
        validTypes: Array,
    },
    data() {
        return {
            fileData: this.input || {},
            progress: 0,
            message: "",

            type: '',
            description: '',
        }
    },
    methods: {
        startUpload() {
            this.fileData.uploading=true
        },
        upload() {
            let self = this
            if (!this.fileData.file) {
                this.message = "Please select a file!";
                return;
            }

            if(this.fileData.uploaded) {
                return;
            }

            this.message = "";

            let formData = new FormData();

            formData.append("file", this.fileData.file);
            let csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            formData.append('_token', csrf);
            formData.append('type', this.type)
            formData.append('description', this.description)

            let url = route('documents.store');
            let config = {
                onUploadProgress(progressEvent) {
                    let percentCompleted = Math.round((progressEvent.loaded * 100) /
                        progressEvent.total);

                    self.progress = percentCompleted;
                    self.$emit('update-progress',{fileIndex: self.fileIndex, loadedSize:progressEvent.loaded, totalSize: progressEvent.total})
                },
            };
            axios.post(url, formData, config).
                then(response => {
                    self.message = response.data.message
                    self.fileData.uploaded = true
                    self.fileData.uploading = false
                }).
                catch(error => {
                    self.message = error.message
                    self.fileData.uploading = false
                });
        },
        remove: function() {
            this.$emit('remove-file', this.fileIndex)
        },
    },
    computed: {
        formatSize() {
            let bytes=this.fileData.file.size;
            let decimals = 0;

            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];

        },
        isTooBig() {
            return this.fileData.file.size > this.maxSize
        },
        isTooSmall() {
            return this.fileData.file.size < this.minSize
        },
        isValidType() {
            let this_obj = this
            return this.validTypes.some(type=>(type===this_obj.fileData.file.type))
        },
        isValid() {
            return !this.isTooBig && !this.isTooSmall && this.isValidType
        },
        errorMessages() {
            let messages = []
            if(this.isTooBig)
                messages.push('File is too large')
            if(this.isTooSmall)
                messages.push('File is too small')
            if(!this.isValidType)
                messages.push('File Type is not allowed')
            return messages
        },
        uploading() {
            return this.fileData.uploading
        },
        fileUploaded() {
            return this.fileData.uploaded
        },
        url() {
            return URL.createObjectURL(this.fileData.file)
        }
    },
    watch: {
        uploading: function (uploading){
            if(uploading) {
                this.upload()
            }
        },
    }
}
</script>

<style scoped>
    .progress-file {
        margin: 7px 8px;
    }

    .v-card__text {
        padding: 4px !important;
    }

    .container {
        padding: 0px !important;
    }

    .file-error {
        color: red;
        font-weight: bold;
        font-size: 10px;
    }
</style>
